var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_100_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0C9.4016 0 0 9.4016 0 21C0 32.5984 9.4016 42 21 42C32.5976 42 42 32.5984 42 21C42 9.4016 32.5984 0 21 0ZM31.6116 21.6382H30.747V30.4426C30.747 31.3712 29.9939 32.1251 29.0645 32.1251H24.2443V26.4387C24.2443 25.5429 23.8809 24.7316 23.2936 24.1443C22.7071 23.5577 21.8958 23.1943 21 23.1943C19.2084 23.1943 17.7557 24.6463 17.7557 26.4387V32.1251H12.9355C12.0061 32.1251 11.253 31.3712 11.253 30.4426V21.6382H10.3884C8.81016 21.6382 8.0932 19.6662 9.30316 18.6523L18.8385 10.6608C20.0895 9.61324 21.9105 9.61324 23.1615 10.6608L32.6968 18.6523C33.9068 19.6662 33.1898 21.6382 31.6116 21.6382Z",
    fill: "#394E60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_100_480",
    x: 0,
    y: 0,
    width: 42,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_100_480"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.73c408f7fecc39be82ed17d564280702.svg";
export { ForwardRef as ReactComponent };